import styled from "styled-components";
const ButtonGroupWrapper = styled.div`
  h1 {
    color: #f80e46;
    font-weight: bold;
    font-size: 18px;
    margin-bottom: 20px;
  }
  .ant-col {
    padding: 0.25rem;
  }

  /* White quick-action buttons with a coloured icon (Figma). */
  button.ant-btn.ant-btn--sf-dashboard,
  .ant-btn.ant-btn--sf-dashboard {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 6px;
    height: auto;
    min-height: 74px;
    padding: 14px 8px;
    border-radius: 10px;
    border: 1px solid #e5e7eb;
    background-color: #ffffff;
    color: #0B2A1B;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);
    white-space: normal;
    line-height: 1.2;
    transition: all 0.15s ease;
  }
  .ant-btn.ant-btn--sf-dashboard .sf-btn-icon {
    font-size: 20px;
    color: #067647;
    line-height: 1;
  }
  .ant-btn.ant-btn--sf-dashboard .sf-btn-label {
    font-size: 13px;
    font-weight: 600;
    text-align: center;
  }
  .ant-btn.ant-btn--sf-dashboard:hover,
  .ant-btn.ant-btn--sf-dashboard:focus {
    border-color: #067647;
    background-color: #f0faf4 !important;
    color: #0B2A1B !important;
  }
  .ant-btn.ant-btn--sf-dashboard:hover .sf-btn-icon {
    color: #067647;
  }

  .statistic-card {
    background: #ffffff;
    border: 1px solid #e5e5e5;
    box-sizing: border-box;
    box-shadow: 1px 1px 10px rgba(229, 229, 229, 0.6);
    border-radius: 10px;
    margin-bottom: 15px;
    padding: 16px;
  }
`;

export default ButtonGroupWrapper;
